const duplicateTranslationKey = (key: string): string => key;

export const translationStatistics_en_part2 = {
  recentReports: "Recent reports",
  reportJobsHelp:
    "Reports continue in the background. Return here to download them for seven days.",
  reportQueued: "Report queued. You can follow its progress under Recent reports.",
  reportJobsLoadError: "Could not load or update reports. Please try again.",
  reportRefusedScopeEmpty:
    "The current view has no chatbots to report on. Choose chatbots at the top of the page and try again.",
  reportRefusedAccessDenied:
    "You don't have access to all of the selected chatbots. Choose chatbots you have access to and try again.",
  reportRefusedQueueFull:
    "Too many reports are queued right now. Try again when a queued report has finished.",
  reportRefusedDateRange: "The selected period is invalid. Check the start and end dates.",
  reportJob_queued: "Queued",
  reportJob_statistics: "Preparing statistics",
  reportJob_analysis: "Analyzing conversations",
  reportJob_rendering: "Generating PDF",
  reportJob_uploading: "Saving report",
  reportJob_delivery: "Sending scheduled report",
  reportJob_ready: "Ready to download",
  reportJob_failed: "Report failed",
  reportJob_cancelled: "Cancelled",
  reportJob_expired: "Expired",
  reportJob_complete: "Complete",
  reportJobAnalysisInterrupted: "Analysis was interrupted. Generate a new report to try again.",
  reportJobTooLarge:
    "This report is too large to generate. Choose a shorter period or fewer chatbots.",
  reportJobBusy:
    "The report service was busy and could not finish this report. Run it again in a few minutes.",
  reportJobTimeout:
    "This report took too long to generate. Run it again, or choose a shorter period.",
  reportJobAccess: "You no longer have access to all chatbots in this report.",
  reportJobDeliveryFailed: "The report was generated, but its email could not be sent.",

  // New translations for report generation
  generateReport: "AI report",
  generateReportTitle: "AI Statistics Report",
  selectReportTimePeriod: "Select time period for the report",
  selectReportEmne: "Select topic (optional)",
  allTopics: "All topics",
  cancel: "Cancel",
  reportGeneratedSuccess: "Report generated and downloaded",
  reportGenerationError: "Error generating report",
  reportAiAnalysisFailed:
    "The report was generated, but the AI insights could not be created. Please try again later.",
  includeTextAnalysis: "Include text analysis (word correlation)",
  includeGPTAnalysis: "Include AI analysis and insights",
  maxConversations: "Number of conversations to analyze",
  loading: "Loading...",
  companyInfo: "Company Information",
  livechat: "Livechat",
  statistics: "Statistics",
  companyInfoPlaceholder: "Enter company information here...",
  startDate: "Start date",
  endDate: "End date",
  // Purchase tracking translations
  // Purchase tracking translations
  totalPurchases: "Total Purchases",
  totalRevenue: "Total Revenue",
  averagePurchaseValue: "Average Purchase Value",
  conversionRate: "Conversion Rate",
  storeTotalPurchases: "Store Purchases (all)",
  storeTotalRevenue: "Store Revenue (all)",
  storeAveragePurchaseValue: "Store Average Order Value (all)",
  storeConversionRate: "Store Conversion Rate (all)",
  storeConversionRateVisitors: "Store Conversion Rate (per daily visitor)",
  returnRate: "Return Rate",
  returnValueRate: "Returned Revenue",
  returnUnitRate: "Returned Items",
  storeReturnRate: "Store Return Rate (all)",
  storeReturnValueRate: "Store Returned Revenue (all)",
  storeReturnUnitRate: "Store Returned Items (all)",
  returnCohortBasis: "Matured orders",
  returnCurveTitle: "Returns by order age",
  returnCurveChatbotSeries: "Chatbot conversations",
  returnCurveStoreSeries: "Whole store",
  returnCurveFooter:
    "Numbers in brackets are the matured orders behind each point. Customers who message the chatbot are not a random sample of customers, so the gap between the lines describes the two groups — it does not prove an effect of the chatbot.",
  trackingSince: "Tracking since",
  // Fallback rate translations
  // Fallback rate translations
  resolutionRate: "Resolution rate",
  handoverRequiredRate: "Customer service required",
  fallbackRate: "Fallback Rate",
  userRequestedCustomerServiceRate: "User requested customer service",
  resolutionCategoryFilterApplied: "Showing conversations with",
  ligegyldigRate: "Meaningless Rate",

  // Export conversations translations

  // Export conversations translations
  exportConversations: "Export Conversations",
  exportConversationsTitle: "Export Conversations",
  exportCenterTitle: "Export Center",
  rawConversationsExport: "Raw conversations",
  statisticsExport: "Statistics",
  exportFormat: "Format",
  runExport: "Run export",
  includeChatbotId: "Include chatbot id",
  conversationDataMessageTypes: "Conversation data message types",
  statisticsMode: "Statistics mode",
  statisticsBreakdowns: "Breakdowns",
  summaryFields: "Summary fields",
  conversationDetails: "Conversation details",
  exportTemplateName: "Template name",
  saveTemplate: "Save template",
  loadTemplate: "Load template",
  updateTemplate: "Update template",
  templateSaved: "Template saved",
  templateUpdated: "Template updated",
  templateDeleted: "Template deleted",
  templateName: "Template name",
  templateNamePlaceholder: "Template name",
  selectTemplate: "Select template",
  exportTemplates: "Export templates",
  savedTemplates: "Saved templates",
  saveAsTemplate: "Save as template",
  deleteTemplate: "Delete template",
  confirmDeleteTemplate: "Delete this template? This cannot be undone.",
  noTemplatesSaved: "No saved templates yet",
  scheduleReport: "Schedule report",
  scheduleReports: "Schedule reports",
  recipientEmails: "Recipient emails",
  recipientEmailsHelp: "Separate multiple email addresses with commas",
  scheduleRecipients: "Recipients",
  scheduleRecipientsPlaceholder: "email@example.com",
  scheduleFrequency: "Frequency",
  daily: "Daily",
  weekly: "Weekly",
  monthly: "Monthly",
  weekday: "Weekday",
  scheduleWeekdayMonday: "Monday",
  scheduleWeekdayTuesday: "Tuesday",
  scheduleWeekdayWednesday: "Wednesday",
  scheduleWeekdayThursday: "Thursday",
  scheduleWeekdayFriday: "Friday",
  scheduleWeekdaySaturday: "Saturday",
  scheduleWeekdaySunday: "Sunday",
  dayOfMonth: "Day of month",
  [duplicateTranslationKey("timeOfDay")]: "Time of day",
  scheduleTimeOfDay: "Time of day",
  scheduleCreated: "Report schedule saved",
  scheduleDeleted: "Report schedule deleted",
  deleteSchedule: "Delete schedule",
  createSchedule: "Create schedule",
  scheduleRequiresTemplate: "Save or load a template before scheduling.",
  saveTemplateBeforeScheduling: "Save or choose a template before scheduling",
  breakdownPerChatbot: "Breakdown per chatbot",
  breakdownPerCategory: "Breakdown per category",
  includeConversationDetails: "Include conversation details",
  includeUserMessages: "Include user messages",
  includeAiMessages: "Include AI messages",
  includeSystemMessages: "Include system messages",
  includeMetricSummary: "Include metrics",
  scheduleSectionTitle: "Email schedule",
  templatesSectionTitle: "Templates",
  settingsUpdatedForNewOptions: "Template updated with new default settings",
  exportTemplateCompatibilityNotice:
    "Template updated with new default options. Please review before exporting.",
  selectExportTimePeriod: "Select time period for the export",
  exportCustomRangeRequired: "Please select both start and end date for a custom export.",
  exporting: "Exporting...",
  exportToCsv: "Export to CSV",
  exportToXlsx: "Export to XLSX",
  exportSuccess: "Conversations exported",
  exportError: "Failed to export conversations. Please try again.",
  exportGeneratedSuccess: "Export generated successfully",
  exportTemplatesLoadError: "Failed to load export templates",
  exportFailed: "Export failed",
  authTokenMissing: "Authentication token missing",
  noConversationsFound: "No conversations found for the selected criteria",
  splitByChatbotId: "Split by Chatbot ID",

  // Settings translations

  // Settings translations
  notifications: "Notifications",
  settingsButton: "Settings",
};
